if (!customElements.get('house-number-visualizer')) {
  customElements.define(
    'house-number-visualizer',
    class HouseNumberVisualizer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true' || this.dataset.initializing === 'true') return;
        this.dataset.initializing = 'true';

        requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.dataset.initialized === 'true') return;

        delete this.dataset.initializing;
        this.dataset.initialized = 'true';

        this.numberInput = this.querySelector('[data-number-input]');
        this.styleSelect = this.querySelector('[data-style-select]');
        this.previewNumbers = this.querySelector('[data-preview-numbers]');
        this.previewButton = this.querySelector('[data-preview-button]');
        this.slider = this.querySelector('[data-comparison-range]');
        this.stage = this.querySelector('[data-preview-stage]');
        this.beforeImage = this.querySelector('[data-before-image]');
        this.afterImage = this.querySelector('[data-after-image]');
        this.thumbnails = [...this.querySelectorAll('[data-house-thumbnail]')];
        this.startButton = this.querySelector('[data-start-preview]');

        if (!this.slider || !this.stage || !this.numberInput) {
          this.dataset.initialized = 'false';
          requestAnimationFrame(() => this.connectedCallback());
          return;
        }

        this.updatePreview = this.updatePreview.bind(this);
        this.updateComparison = this.updateComparison.bind(this);

        this.numberInput?.addEventListener('input', this.updatePreview);
        this.styleSelect?.addEventListener('change', this.updatePreview);
        this.previewButton?.addEventListener('click', this.updatePreview);
        this.slider?.addEventListener('input', this.updateComparison);

        this.startButton?.addEventListener('click', () => {
          this.numberInput?.focus({ preventScroll: true });
          this.querySelector('[data-controls]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });

        this.thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => this.selectHouse(thumbnail));
        });

        if (this.thumbnails.length) this.selectHouse(this.thumbnails[0]);
        this.updatePreview();
        this.updateComparison();
      }

      updatePreview() {
        if (!this.previewNumbers) return;

        const maximumLength = Number(this.numberInput?.maxLength || 8);
        const cleaned = (this.numberInput?.value || '')
          .replace(/[^0-9A-Za-z-]/g, '')
          .slice(0, maximumLength);

        if (this.numberInput && this.numberInput.value !== cleaned) {
          this.numberInput.value = cleaned;
        }

        this.previewNumbers.textContent = cleaned || this.dataset.defaultNumber || '1234';
        this.previewNumbers.dataset.style = this.styleSelect?.value || 'gotham';
      }

      updateComparison() {
        if (!this.stage || !this.slider) return;
        this.stage.style.setProperty('--comparison-position', `${this.slider.value}%`);
      }

      selectHouse(thumbnail) {
        const source = thumbnail.dataset.imageSrc;
        if (!source) return;

        if (this.beforeImage) {
          this.beforeImage.hidden = false;
          this.beforeImage.src = source;
          this.beforeImage.alt = thumbnail.dataset.imageAlt || '';
        }
        if (this.afterImage) {
          this.afterImage.hidden = false;
          this.afterImage.src = source;
          this.afterImage.alt = '';
        }

        this.style.setProperty('--number-x', `${thumbnail.dataset.numberX || 69}%`);
        this.style.setProperty('--number-y', `${thumbnail.dataset.numberY || 48}%`);
        this.style.setProperty('--number-scale', Number(thumbnail.dataset.numberScale || 100) / 100);

        this.thumbnails.forEach((item) => {
          const selected = item === thumbnail;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      }
    }
  );
}
